import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

const defaultProps = {
  selected: false,
  disabled: false
};

const QuizInput = props => {
  let image = props.image;
  let title = props.title;

  return (
    <button
      className={
        "button " +
        (props.isConfirmationChallenge
          ? "confirmation-button cta inline"
          : "fullwidth quizinput") +
        (props.selected ? " selected" : "") +
        (props.disabled ? " pseudo-readonly cursor-not-allowed" : "")
      }
      onClick={() => props.onClick(props.id)}
    >
      {props.image ? (
        <img className="automargin pure-img" src={image} alt={title} />
      ) : null}
      {title}
    </button>
  );
};

QuizInput.propTypes = propTypes;
QuizInput.defaultProps = defaultProps;

export default QuizInput;
